<template>
	<v-app>
		<router-view name="login"></router-view>
		<v-content :class="{ 'pa-0' : $route.name === 'login' }">
			<v-progress-linear
				class="progress-bar"
				v-bind:indeterminate="isLoading"
				v-if="isLoading">
			</v-progress-linear>
			<router-view></router-view>
		</v-content>
		<v-snackbar :timeout="snackbar.timeout" :color="snackbar.color"
			:top="true" :right="true" v-model="snackbar.isVisible">
			<p class="ma-0" v-html="snackbar.text"></p>
			<!-- {{ snackbar.text }} -->
			<v-btn flat @click.native="snackbar.isVisible = false">Cerrar</v-btn>
		</v-snackbar>
	</v-app>
</template>

<script>

function created() {
	this.onToggleSnackBar();
	this.$bus.$on('is-loading', (result) => {
		this.isLoading = result;
	});
}

function data() {
	return {
		isLoading: false,
	};
}

export default {
	name: 'app',
	created,
	data,
};
</script>

<style lang="scss">
html {
	font-size: 16px;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

img {
	vertical-align: middle;
}

.content {
	background: white;
	padding: 133px 12px 0px !important;

	&--wrap {
		background-color: map-get($colors, background-table);
		padding: 0px;
	}

	@media (min-width: 768px) {
		// padding: 115px 0px 0px !important;
		padding: 55px 0px 0px 53px !important;
	}

	@media (min-width: 1264px) {
		padding: 55px 0px 0px 53px !important;
	}
}

.chk-all {
	&.input-group {
		.input-group__input {
			.icon {
				font-size: 18px !important;
				height: 18px;
			}
		}
		.input-group__details {
			display: none;
		}
	}
}

.japi-input-text {
	margin-bottom: 17px;
	label {
		padding-left: 15px;
	}
	&.input-group {
		.input-group__input {
			background-color: white;
			border-radius: 3px;
			box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.2);
			height: 33px;
			padding-left: 15px;
		}
		.input-group__details {
			display: none;
		}
	}
}

.japi-input-text-table {
	margin: 10px 0;
	label {
		padding-left: 5px;
	}
	&.input-group {
		padding: 0;
		.input-group__input {
			background-color: white;
			border-radius: 3px;
			box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.2);
			padding-left: 5px;
			input {
				height: 100%;
				font-size: 13px;
			}
		}
		.input-group__details {
			display: none;
		}
	}
}

.japi-input-text-error {
	margin-bottom: 10px;
	label {
		color: map-get($colors, error) !important;
		padding-left: 15px;
	}
}

.japi-input-textarea {
	margin-bottom: 10px;
	label {
		padding-left: 15px;
	}
	&.input-group {
		.input-group__input {
			background-color: white;
			border-radius: 3px;
			box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.2);
			padding-left: 15px;
		}
		.input-group__details {
			display: none;
		}
	}
}

.japi-input-select {
	margin-bottom: 10px;
	label {
		padding-left: 15px;
	}
	&.input-group {
		.input-group__input {
			background-color: white;
			border-radius: 3px;
			box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.2);
			height: 33px;
			padding-left: 15px;
		}
		.input-group__details {
			display: none;
		}
	}
}

.bars-align {
	.list__tile {
		justify-content: flex-end;
		padding-left: 2px;

		&--avatar {
			height: 40px;
		}
	}
}

main.content.pa-0 {
	padding: 0px !important;
}

.progress-bar {
	left: 0px !important;
	margin: 0px !important;
	position: absolute !important;
	right: 0px !important;
	top: 55px !important;

	@media (min-width: 768px) {
		top: 54px !important;
	}
}

.sidebar-bg {
	height: calc(100vh - 70px);
	
	&.list {
		.list__group {
			&__header {
				&__prepend-icon,
				&__append-icon {
					display: none;
				}

				&:hover {
					background: transparent;
				}

				.list__tile {
					font-family: map-get($fonts, open-semibold);
					font-size: 18px;
					opacity: 1;
					padding: 0 16px 0 26px;

					&:hover,
					&--active {
						background: transparent;
						opacity: 1;
					}
				}

				&--active {
					.list__tile {
						opacity: 1;
					}
				}
			}

			&__items {
				padding: 10px 0;
    			background: #5c6fb3;
				&.padding-items {
					padding-bottom: 12px;
				}

				.list__tile {
					font-size: 13px;
					height: 28px;
					opacity: 1;
					padding-left: 16px;
					padding-right: 0px;

					&:hover,
					&--active {
						background: transparent;
						opacity: 1;
					}

					&__action {
						justify-content: flex-start;
						min-width: 26px;

						.icon {
							font-size: 6px;
						}
					}
				}
			}

			&:before,
			&:after {
				background: #7689ce;
			}
		}
	}
}

.char-value-select {
	&.input-group {
		.input-group__input {
			.icon {
				font-size: 18px !important;
				height: 18px;
			}
		}

		label {
			color: map-get($colors, paginationText) !important;
			font-size: 13px;
		}
	}
}

.sidebar-border {
	z-index: 9;
	
	.navigation-drawer__border {
		// background-color: map-get($colors, primary) !important;
		background-color: #818CB4 !important;
		width: 0;
	}

	&.navigation-drawer--mini-variant {
		.list__group__header {
			.list__tile {
				padding-left: 0px;

				&__content {
					display: none;
				}
			}
		}
	}
}

.columns-menu {
	&.menu__content {
		background-color: white;
		border-radius: 4px;
		box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, .4);
		max-width: 170px;
		padding-left: 5px;
		padding-right: 5px;

		.input-group {
			label {
				color: map-get($colors, subheaderText);
				font-family: map-get($fonts, open-semibold);
				font-size: 13px;
				line-height: 21px;
			}

			&__input {
				min-height: 20px;

				.icon {
					font-size: map-get($sizes, medium);
					height: 5px !important;
				}
			}

			&--selection-controls__ripple {
				height: 10px;
				transform: translate(2px, 0%);
				width: 10px;
			}
		}

		.apply {
			border-top: 1px solid #e5e5e5;
			margin-top: 5px;

			button {
				color: map-get($colors, info);
				font-family: map-get($fonts, open-semibold);
				font-size: 13px;
				outline: none;
			}
		}
	}
}

.select-chips_code {
	&.input-group {
		background: white;
		border: 1px solid map-get($colors, background-card);
		border-radius: 3px;
		box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, .2);
		min-height: 30px;
		&.input-group.input-group--solo {
			box-shadow: none;
			label {
				color: map-get($colors, paginationText);
				font-family: map-get($fonts, open-light);
				font-size: 13px;
				top: 1px;
			}
		}
	}
	&.shadow-inset {
		border-radius: 3px;
		// box-shadow: inset 0px 0px 1px 1px rgba(0, 0, 0, .2);
		box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
	}
}

.filter-select {

	&.input-group--text-field.input-group--multi-line textarea {
		padding: 4px 15px !important;
	}

	&.input-group {
		background: white;
		border-radius: 2px;
		box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, .2);
		padding: 0px;

		&.shadow-inset {
			border-radius: 3px;
			// box-shadow: inset 0px 0px 1px 1px rgba(0, 0, 0, .2);
			box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
			// background: orange;

			&-chip {
				border-radius: 5px;
				box-shadow: inset 0px 0px 1px 0px rgba(0, 0, 0, .5);
				height: 30px;
				left: 33px;
				max-width: 124px;
				position: absolute;
				top: 1.5px;
				width: 100%;

				input {
					color: map-get($colors, subheaderText);
					font-family: map-get($fonts, open-semibold);
					font-size: map-get($sizes, medium);
					padding: 0 19px;
					text-align: right;
				}

				label {
					color: map-get($colors, subheaderText);
					font-family: map-get($fonts, open-semibold);
					font-size: map-get($sizes, medium);
					height: 30px;
					left: auto;
					line-height: 30px;
					text-align: right;
					right: 19px;
				}
			}

			&-table {
				border-radius: 3px;
				box-shadow: none;
				display: inline-flex;
				height: 22px;
				max-width: 72px;

				.input-group__input {
					min-height: 22px;
				}

				input {
					border-radius: 3px;
					box-shadow: inset 0px 1px 1px 0px rgba(0, 0, 0, .2);
					color: map-get($colors, paginationText);
					font-size: map-get($sizes, small);
					height: 22px;
					padding: 0 5px;
					text-align: right;
				}

				label {
					color: map-get($colors, subheaderText);
					font-size: map-get($sizes, medium);
					height: 22px;
					left: auto;
					line-height: 22px;
					text-align: right;
					right: 5px;
				}
			}

			.input-group__selections {
				border-width: 1px;
				height: 24px;
				&__comma {
					color: map-get($colors, paginationText) !important;
				}
			}

			.input-group__append-icon {
				width: 26px;
			}

			input {
				color: map-get($colors, paginationText) !important;
				font-family: map-get($fonts, open-semibold);
				font-size: map-get($sizes, medium);
				height: 30px;
				padding-left: 14px;

				&[readonly] {
					color: map-get($colors, subheaderText) !important;
				}
			}

			label {
				color: map-get($colors, paginationText) !important;
				height: 30px;
				line-height: 30px;
			}

			&-calendar {
				.icon {
					background: map-get($colors, orange-btn);
					border-bottom-right-radius: 2px;
					border-top-right-radius: 2px;
					color: white !important;
					font-size: 24px;
					height: 30px;
					line-height: 32px;
					padding-left: 3px;
					width: 30px;
				}

				&.shadow-inset-calendar-start {
					.icon {
						background: map-get($colors, success);
					}
				}

				&.shadow-inset-calendar-start,
				&.shadow-inset-calendar-end {
					.icon {
						height: 28px;
						line-height: 30px;
					}
				}

				&.shadow-inset-calendar-requirement {
					.icon {
						background: white;
						border: 1px solid map-get($colors, blue-purchase);
						color: map-get($colors, blue-purchase) !important;
						height: 28px;
						line-height: 30px;
					}
				}
			}

			&.input-address {
				.input-group__input {
					padding-right: 7px;
				}

				.input-group__append-icon {
					background-color: map-get($colors, orange-btn);
					border-radius: 4px;
					box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, .3);
					color: white !important;
					font-size: 16px;
					height: 20px;
					padding-top: 2px;
					text-align: center;
					width: 20px;
				}
			}

			&.input-time-picker {
				.input-group--text-field__suffix {
					color: map-get($colors, paginationText) !important;
					font-family: map-get($fonts, open-semibold);
					font-size: map-get($sizes, medium);
					height: 28px;
					margin: 0px;
					padding-right: 20px;
				}
			}

			&.textarea-content {
				// border: none !important;
				min-height: 85px;
				border: 1px solid map-get($colors, border-input)!important;
				label {
					top: -1px;
				}

				.input-group__input {
					border: none !important;
				}

				textarea {
					padding-top: 7px;
				}
			}
		}

		&--autocomplete {
			input {
				color: map-get($colors, subheaderText);
				font-size: 13px;
				padding-left: 14px;
			}
		}

		&--text-field {
			label {
				color: map-get($colors, subheaderText) !important;
				font-family: map-get($fonts, open-light);
				font-size: 13px;
				height: 33px;
				left: 13px;
				line-height: 33px;
				top: 0px;
			}
		}

		&--select {
			.input-group__selections {
				// border-right: 2px solid map-get($colors, grey-border);
				height: 27px;
				margin-top: 3px;

				&__comma {
					color: map-get($colors, subheaderText) !important;
					font-family: map-get($fonts, open-light);
					font-size: 13px;
					padding-left: 13px;
				}
			}
		}

		.input-group__append-icon {
			color: map-get($colors, subheaderText) !important;
			font-size: 28px;
			padding: 0px 5px 0px 0px;
			// width: 25px;
		}

		.input-group__details {
			display: none;
		}
	}

	&.input-group.input-group--multiple {
		height: auto;

		.input-group__selections {
			height: auto;
			margin: 0px;
			padding-left: 10px;
		}
	}

	&-content {
		.list {
			&__tile {
				color: map-get($colors, subheaderText);
				font-family: map-get($fonts, open-light);
				font-size: 13px;
				height: 33px;
			}
		}
	}

	&.input-group--textarea {
		min-height: 80px !important;

		.input-group__input {
			border: 0px !important;
			min-height: 80px !important;
			padding: 5px 10px !important;
		}

		textarea {
			font-family: map-get($fonts, open-semibold);
			font-size: 14px !important;
			padding: 4px 15px !important;
		}
	}

	&.input-group--text-field.input-group--dirty:not(.input-group--full-width).input-group--textarea label {
		transform: translate(0, -19px) scale(0.75) !important;
	}

	&.input-group{
		border-radius: 8px!important;
		border: 1px solid map-get($colors, border-input);
		box-shadow: none!important;
	}
}
.btn {
	&.rounded {
		border-radius: 5px;
	}
	&.not-shadow{
		box-shadow: none!important;
	}
	&.tandia-btn-outline {
		box-shadow: none!important;
		border-radius: 8px!important;
		border: 1px solid map-get($colors, border-input)!important;
	}
	&.btn-default-outline {
		box-shadow: none!important;
		border-radius: 8px!important;
		border: 1px solid map-get($colors, border-input)!important;
	}
}

.show-error {
	.input-group__details {
		font-size: map-get($sizes, small10);
		display: block !important;
		padding-top: 0;
	}
	.input-group__details:before {
		height: 0px;
	}
}

.table-style {
	.table__overflow {
		.table {
			thead tr {
				background-color: map-get($colors, primary);
				height: 30px;
				th { color: white !important; }
			}
			tbody tr:nth-child(even) {
				background-color: map-get($colors, background-sidebar);
			}
		}
	}
}

.general-filter-button {
	height: 33px !important;
	min-width: auto !important;

	.btn__content {
		justify-content: center;
		padding: 0px;
	}
}

.header-page-download-document {
	.btn__content {
		padding: 0px;
	}
}

.modal-filter-footer {
	background-color: white;
	bottom: 0%;
	left: 0px;
	padding: 10px 0;
	position: fixed;
	right: 0px;
	width: 100%;
	z-index: 2;
}

.filter-by-row {
	.input-group {
		padding-left: 18px;

		label {
			color: map-get($colors, subheaderText) !important;
			font-family: map-get($fonts, open-semibold);
			font-size: 13px;
			margin-left: 18px;
		}

		&__input {
			.icon {
				font-size: map-get($sizes, medium);
				height: 12px !important;
			}
		}
	}

	&.filter-by-row-sales {
		.input-group {
			label {
				color: map-get($colors, paginationText) !important;
				font-family: map-get($fonts, open-semibold) !important;
				font-size: map-get($sizes, medium) !important;
				height: auto;
				line-height: 1.2;
				white-space: normal !important;
			}
		}
		
 		.icon {
			top: 9px !important;
		}
	}
}

.chip-exchange {
	.chip__content {
		height: 20px;
		letter-spacing: normal;
		line-height: 1;
		padding: 0px 10px;
		white-space: normal;
	}
}

.radio-group.sale-radio, .selling-points {
	.input-group {
		&__input {
			min-height: 19px;

			label {
				color: map-get($colors, subheaderText);
				font-size: map-get($sizes, medium);
				height: 19px;
				left: 16px;
				line-height: 19px;
			}

			.icon {
				font-size: map-get($sizes, small);
				height: 13px !important;
			}
		}

		&__details {
			display: none;
		}
	}

	&.radio-expansion-panel {
		&.input-group {
			padding: 5px 0px;
		}

		.input-group {
			&__input {
				display: flex;
				flex: 1 1 auto;
				flex-direction: row;
				flex-wrap: wrap;
				min-height: 19px;
				min-width: 0;

				label {
					color: map-get($colors, paginationText);
					font-size: 13px;
					height: 19px;
					left: 20px;
					line-height: 21px;
					text-transform: capitalize;
				}

				.icon {
					font-size: 16px;
					height: 16px !important;
				}
			}

			&__details {
				display: none;
			}
		}
	}

	.sale-radio-ticket {
		padding-left: 0px;
		padding-right: 44px;

		label {
			width: auto;
		}
	}

	.sale-radio-note {
		padding-left: 0px;
		padding-right: 16px;

		@media (min-width: 768px) {
			padding-right: 75px;
		}

		label {
			left: 16px;
		}
	}

	.sale-radio-bill {
		padding-right: 28px;
	}
}

.align-col-responsive {
	margin-bottom: 5px;
	text-align: left;

	@media (min-width: 768px) {
		margin-bottom: 0px;
		text-align: center;
	}
}

.pd-col-responsive {
	padding-left: 20px;

	@media (min-width: 768px) {
		padding-left: 0px;
	}
}

.btn-action-requeriment {
	border-radius: 5px !important;
	box-shadow: none !important;
	color: white !important;
	height: 30px !important;
	margin: 0px;
	text-transform: none !important;

	.btn__content {
		font-family: map-get($fonts, open-semibold);
		font-size: map-get($sizes, small10);

		img {
			height: 20px;
			margin-left: 10px;
		}
	}
}
.btn-action-save {
	border: 1px solid map-get($colors, primary) !important;
	border-radius: 5px !important;
	box-shadow: none !important;
	color: map-get($colors, primary) !important;
	height: 30px !important;
	margin: 0px;
	text-transform: none !important;

	.btn__content {
		font-family: map-get($fonts, open-semibold);
		font-size: map-get($sizes, small10);

		img {
			height: 20px;
			margin-left: 10px;
		}
	}
}

.btn-action {
	// border-radius: 5px !important;
	box-shadow: none !important;
	color: white !important;
	height: 30px !important;
	margin: 0px;
	// text-transform: none !important;
	width: 97px !important;

	&-width {
		width: auto !important;
	}

	&-block {
		min-width: auto !important;
		width: 100% !important;
	}

	.btn__content {
		font-family: map-get($fonts, open-semibold);
		font-size: map-get($sizes, small10);
		padding: 0px;

		img {
			height: 20px;
			margin-left: 10px;
		}
	}

	&.text-large {
		.btn__content {
			font-family: map-get($fonts, open-bold);
			font-size: map-get($sizes, small);
		}
	}
}

.change-document-btn {
	.btn__content {
		padding: 0px;
	}
}

.overflow-auto {
	overflow: auto;
	margin-bottom: 30px;
}

.options-menu {
	.btn__content {
		padding: 0px 2px;
	}

	button:hover {
		&:before {
			background-color: transparent !important;
		}
	}

	&-content {
		.list {
			border-radius: 4px;
			box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, .25);
			display: flex;
			padding: 0px;

			&__tile {
				height: 32px;
				padding: 0 8px;
			}
		}
	}
}

.progress-companies {
	.progress-linear__background {
		background-color: transparent !important;
	}
}

.notification {
	&-btn {
		.btn__content {
			padding: 0px;
		}
	}

	&-card {
		.btn__content {
			max-width: 100%;
			padding: 0px 0px 0px 17%;
			white-space: normal;
		}
	}
}

.theme--light {
	.table-icon {
		.btn__content {
			padding: 0px;
		}

		&.btn--disabled {
			&:not(.btn--icon):not(.btn--flat) {
				background-color: transparent !important;
				opacity: .6;
			}
		}
	}
}

.wrapper-create-employee {
	.theme--dark {
		&.btn {
			&.btn--disabled {
				&:not(.btn--icon):not(.btn--flat) {
					background-color: rgba(0,0,0,0.12) !important;
				}
			}
		}
	}
}


.filter-toggle {
	.btn {
		background-color: transparent !important;

		.btn__content {
			height: 28px;

			&:before {
				background-color: transparent !important;
			}
		}

		&.btn--disabled {
			&:not(.btn--icon):not(.btn--flat) {
				background-color: transparent !important;
			}

			.btn__content {
				&:before {
					background-color: transparent !important;
				}
			}
		}
	}
}

.dialog.dialog-cancel {
	border-radius: 10px;
	height: 237px;

	.card {
		height: 237px !important;
		padding: 32px 65px 22px;

		&__title {
			color: map-get($colors, paginationText);
			font-family: map-get($fonts, open-semibold);
			font-size: map-get($sizes, small);
		}
	}
}

.textarea-content {
	.input-group__input {
		border: 1px solid map-get($colors, grey-border) !important;
		border-radius: 0px !important;
		margin-bottom: 15px;
		max-height: 110px;
		padding: 0px !important;

		textarea {
			// border: 1px solid map-get($colors, border-input)!important;
			border-radius: 0px;
			color: map-get($colors, paginationText);
			font-family: map-get($fonts, open-regular);
			font-size: map-get($sizes, small);
			padding-left: 10px;
			padding-top: 10px !important;
		}
	}

	input {
		height: 100% !important;
	}
}

button {
	min-width: 5px;
	outline: none;

	.table-icon {
		outline: none;
	}
}

.input-group--hide-details {
	.input-group__details {
		display: none;
	}
}

#calendar {
	padding: 0px 15px 15px;

	.fc {
		&-toolbar {
			&.fc-header-toolbar {
				margin-bottom: 0px;
			}
		}

		&-button {
			background-color: map-get($colors, background-sidebar);
			background-image: none;
			border: 1px solid map-get($colors, subheaderText);
			box-shadow: none;
			color: map-get($colors, subheaderText);
			font-family: map-get($fonts, open-regular);
			font-size: map-get($sizes, medium);
			height: 25px;
			line-height: map-get($sizes, medium);
			outline: none;
			text-shadow: none;

			&:first-child {
				border-bottom-left-radius: 5px;
				border-top-left-radius: 5px;
			}

			&:last-child {
				border-bottom-right-radius: 5px;
				border-top-right-radius: 5px;
			}
		}

		&-center {
			h2 {
				color: map-get($colors, subheaderText);
				font-family: map-get($fonts, regular);
				font-size: map-get($sizes, medium18);
			}
		}
	}
}

.title-form {
	color: map-get($colors, paginationText);
	font-family: map-get($fonts, open-semibold);
	font-size: 13px;
}

.hr-info {
	background-color: map-get($colors, blue-grey) !important;
}

.form-group__message {
	color: map-get($colors, orange-btn);
	font-family: map-get($fonts, open-semibold);
	font-size: 11px;

	&--full {
		display: block;
	}
}

.pl-add-container {
	@include flex-center;
	background-color: map-get($colors, primary) !important;
	border-radius: 5px;
	display: inline-flex;
	height: 20px;
	width: 20px;
}

.btn-list {
	border-radius: 5px !important;
	box-shadow: none !important;
	height: 25px !important;
	min-width: 30px !important;

	&-add {
		border: 1px solid map-get($colors, primary);
		color: map-get($colors, primary) !important;
	}

	&-remove {
		border: 1px solid map-get($colors, orange-btn);
		color: map-get($colors, orange-btn) !important;
	}

	.btn__content {
		height: 18px;
		padding: 0px;
	}

	.icon {
		font-size: 20px;
	}
}

.custom-loader {
	animation: loader 1s infinite;
	display: flex;
}

.tabs__container--overflow .tabs__div.customer-tabs {
	flex: 0 1 auto;
}

@-moz-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}

@-webkit-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}

@-o-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}

@keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}

.size {
	cursor: pointer;
	height: 30px;
	width: 30px;
}

.fast-register-footer {
	background-color: white;
	bottom: 0%;
	position: fixed;
	width: 100%;
}

.expansion-panel-component {
	.expansion-panel {
		&__header {
			background-color: map-get($map: $colors, $key: expansion-panel-header);
			color: white;
			font-family: map-get($map: $fonts, $key: open-semibold);
			font-size: 13px;
			height: 30px;
			line-height: 1.2;
			padding: 0px 0px 0px 34px;
			text-transform: capitalize;
		}

		&__container .header__icon {
			border-left: 1px solid white;
			height: 30px;
		}

		&__container .header__icon .icon {
			color: white !important;
			font-size: 44px;
			height: 30px;
			line-height: 0.7;
		}
	}
}

.row-background-grey {
	background-color: map-get($map: $colors, $key: background-table);
}

.feature-footer {
	background-color: white;
	bottom: 0;
	position: absolute;
	width: 100%,
}

.opacyble {
	opacity: 0.3;
}

.sidebar-active {
	.list__tile.list__tile--link {
		opacity: 1 !important;
	}
}

.btn-action-bar {
	.btn__content {
		justify-content: flex-start;
		padding: 0px 4px;
	}
}

.action-bar {
	display: flex;
	flex-flow: column;
	width: 60px;
}

.action-bar_element {
	align-items: center;
	background-color: white;
	border: 1px solid color(blue-price);
	border-radius: 4px;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
	color: color(subheaderText);
	display: grid;
	font-size: size(small10);
	grid-template-columns: 35px 1fr;
	grid-template-rows: 40px;
	justify-content: center;
	margin-bottom: 5px;
	padding: 0 11px 0 9px;
	text-align: left;
	transform: translateX(10px);
	transition: transform 200ms ease-out;
	width: 120px;
}

.action-bar_element:hover {
	transform: translateX(-52px);
}

.title-section {
	border-bottom: 1px solid color(blue-grey);
	font-family: font(open-bold);
	font-size: size(medium);

	.btn__content {
		justify-content: space-between;
	}
}

.mr-adjust {
	margin-right: 0;
}

.image-button {
	background-color: color(primary) !important;
	min-width: 30px !important;
	width: 30px !important;
}

.view-image {
    height: 15px !important;
	margin: 0 !important;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
	transform: translateY(30px);
}

.fade-enter-active,
.fade-leave-active {
	transition-property: opacity, transform;
	transition-duration: 0.2s;
}

.fade-left-enter-active {
	animation: lateral 0.3s;
}

.fade-left-leave-active {
	animation: lateral 0s reverse
}

@keyframes lateral {
	0% {
		flex-basis: 0;
	}
	100% {
		flex-basis: 50%;
	}
}

.fade-lateral-enter,
.fade-lateral-leave-to {
	opacity: 0;
	transform: scaleX(0);
}

.fade-lateral-enter-active,
.fade-lateral-leave-active {
	transition-property: opacity, transform, transform-origin;
	transition-duration: 0.3s;
}

.text-field {
	&.input-group.input-group--solo .input-group__input {
		padding: 0 !important;
	}
	&.input-group.input-group--solo {
		min-height: 30px;
		border: 1px solid map-get($colors, border-input)!important;
		border-radius: 6px;
	}
	&.input-group--text-field input, .input-group--text-field textarea {
		font-size: size(small);
	}
}

.select-app {
	&.input-group {
		background: white;
		border-radius: 2px;
		box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, .2);
	}

	.input-group--select__autocomplete,
	.input-group__selections__comma {
		padding-left: 10px;
	}
}

.date-picker-input {
	.input-group.input-group--solo label {
		font-size: size(small);
		top: 0;
	}
}

.is-not-selectable {
	table th {
		&:first-child {
			width: auto !important;
		}
	}
}

.input-group.input-group--selection-controls .input-group__input .icon--selection-control {
	top: 3px;
}

.tabs-form {
	.tabs__slider {
		height: 3px;
	}
}

.tags-form {
	&.chip--small {
		height: 22px;
	}

	.chip__content {
		height: 24px;
	}

	.chip__close > .icon {
		font-size: 18px;
	}
}

button:disabled {
	cursor: not-allowed;
	opacity: 0.6;
}

.jailai {
	animation: jailai 3s ease-in;
}

@keyframes jailai {
	from {
		background: yellow;
	}
	to {
		background: white;
	}
}

.due-btn {
	.btn__content {
		&:before {
			background-color: transparent !important;
		}
	}
}

.form-height {
	min-height: 100vh;
}

.text-uppercase {
	text-transform: uppercase;
}

.btn-auto {
	height: auto !important;
	min-width: auto !important;
	width: auto !important;
}

.btn-full {
	height: auto;
	min-width: auto !important;
	width: 100% !important;
}

.btn-total {
	.btn__content {
		padding: 0px;
	}
}

.primary-select .select-app {
	background-color: map-get($colors, select) !important;
	color: map-get($colors, white) !important;

	.input-group__selections__comma {
		color: map-get($colors, white) !important;
		font-family: map-get($fonts, open-bold);
		font-size: 11px;
	}

	.input-group__append-icon {
		color: map-get($colors, white) !important;
	}
}

.upload-button {
	
	&.btn {
		box-shadow: none;
		height: 30px;
		margin: 0;
		min-width: 0;

		.btn__content .icon {
			color: white;
		}
	}
}

.proof-delete-image {

	.btn--floating.btn--small .icon {
		font-size: size(large);
	}

	.material-icons {
		display: flex;
	}
}

.switch-status {
	&.switch:not(.input-group--dirty) {
		color: map-get($colors, error) !important;

		&.input-group .input-group--selection-controls__toggle {
			opacity: .5;
		}

		.input-group--selection-controls__container {
			color: inherit !important;
		}

		.input-group--selection-controls__ripple:after,
		.input-group--selection-controls__ripple:after {
			background-color: map-get($colors, error);
		}
	}
}

.delete-reason {	
	.select-app {
		max-width: none !important;
	}
}

.tag-chip {
	.chip__content {
		border-radius: inherit;
		height: 18px;
	}
}

.tag-select {
	.input-group__selections {
		height: auto !important;
		min-height: 24px;
	}
}

.subtotal-container {
	position: relative;
}

.subtotal-menu {
	align-items: center;
	background-color: color(summary);
	display: flex;
	font-size: 12px;
	justify-content: center;
	min-width: 270px;
	padding: 10px 15px;
	position: absolute;
	right: 0;
	top: 115%;
	z-index: 3;
}

.subtotal-menu-content {
	font-size: 12px;
	width: 100%;

	p {
		display: flex;
		justify-content: space-between;
		margin-bottom: 8px;
		white-space: nowrap;

		.taxes-title {
			font-family: font(open-regular);
			margin-right: 10px;
		}
	}

	.input-group {
		label {
			font-size: 12px;
		}
	}
}

.prices-width {
	.filter-select.input-group.shadow-inset {
		input {
			padding-left: 5px;
			width: 60px;
		}
	}
}

.input-address-custom {
	.filter-select.input-group .input-group__append-icon {
		background-color: map-get($colors, orange-btn) !important;
		color: map-get($colors, white) !important;
		font-size: map-get($sizes, large);
		height: 100%;
		padding-left: 1.5px;
		padding-top: 3px;
	}
}

.btn-totals {
	border: 1px solid color(subheaderText);
}

.subtotal {
	align-items: center;
	display: flex;
	font-size: 12px;
	justify-content: center;

	button {
		color: color(info);
		margin-left: 8px;
	}
}

.totals-section {
	background-color: color(summary);
	font-family: font(open-bold);
}

.product-search-custom {
	.filter-select.input-group .input-group__append-icon {
		background-color: map-get($colors, primary);
		border-bottom-right-radius: 5px;
		border-top-right-radius: 5px;
		color: map-get($colors, white) !important;
		font-size: 24px;
		height: 100%;
		line-height: 31px;
		padding: 0px 3px;
		width: 30px;
	}
}

.btn-action.btn-width-auto {
	height: auto !important;
	width: auto !important;
}

.textarea-custom {
	&.filter-select {
		height: 80px !important;

		.input-group__input {
			border: 0px !important;
			padding: 5px 15px !important;

			textarea {
				font-family: map-get($fonts, open-semibold);
				font-size: 14px;
				resize: none;
			}
		}
	}
}

.custom-autocomplete {
	.filter-select.input-group.shadow-inset .input-group__selections {
		border-right: 0px;

		& + div + i {
			font-size: 20px;
		}
	}

	&.custom-autocomplete-search {
		.filter-select.input-group.shadow-inset .input-group__selections {
			& + div + i {
				color: map-get($colors, primary) !important;
				font-size: 24px;
				padding-right: 2px;
			}
		}	
	}
}

.input-group--select.input-group--focused.input-group--open .input-group__append-icon:not(.input-group__icon-clearable) {
	transform: none;
}

.chip.chip-search {
	.chip__content {
		border-radius: 8px;
		font-family: map-get($fonts, open-semibold);
		font-size: map-get($sizes, small10);
		height: 17px;
		padding: 0px 6px;
	}
}

.filter-select-content.custom-select-content-search .list__tile {
	height: 68px;

	.input-group--select.input-group--focused.input-group--open .input-group__append-icon:not(.input-group__icon-clearable) {
		transform: none;
	}
}

.custom-select-content {
	border-radius: 0px;
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;

	.list__tile--highlighted {
		border-bottom: 1px solid map-get($colors, blue-grey);
	}

	.list__tile__title,
	.list__tile__sub-title {
		//color: map-get($colors, paginationText);
		font-size: 11px;
		height: 13px;
		line-height: 11px;
	}

	.list__tile__sub-title {
		height: auto;
		margin-top: 2px;
	}
}

.custom-select-content-open {
	display: inline-block !important;
	z-index: 8 !important;
}

.switch-status.switch-tax {
	label {
		color: map-get($colors, paginationText) !important;
		font-family: map-get($fonts, open-bold);
		font-size: map-get($sizes, small);
		padding-left: 10px !important;
	}
}

.hide-and-print,
.menuable__content__active {
	@media print {
		display: none !important;
	}
}

.item-container {
	.progress-circular__info {
		width: 80%;
	}
}

.warehouse-btn {
	.btn__content {
		justify-content: space-between !important;
	}
}

.filter-checkbox {
	align-items: center !important;
	
	&.input-group.input-group--selection-controls .input-group__input .icon--selection-control {
		top: 9px !important;
	}
}

.action-td {
	min-width: 128px !important;
}

.switch-inline {
	display: inline-block !important;
	margin-right: 8px;
	vertical-align: middle;
	width: auto !important;
}

.br-8 {
	border: 1px solid map-get($colors, border-tab);
	border-radius: 8px;

	.tabs__bar,
	.tabs__items {
		border-color: map-get($colors, border-tab);
		border-radius: 8px;
	}
}

.btn-new-product {
	height: 30px !important;
	min-width: auto !important;

	.btn__content {
		min-width: auto !important;
		padding: 0 4px !important;
	}
}

.collapse-btn {
	.btn__content {
		justify-content: space-between !important;
		padding: 0px !important;
	}
}

.excel-menu-content {
	border: 1px solid map-get($colors, borderRowSelected);
	border-radius: 3px;

	.list {
		border-radius: 3px;
		padding: 0px;

		& > div {
			border-bottom: 1px solid map-get($colors, blue-grey);
			margin: 0px 16px;

			a div {
				text-align: center;
			}

			&:last-child {
				border-bottom: 0px;
			}
		}
	}

	.list__tile {
		height: 28px !important;
	}

	.list__tile__title {
		color: map-get($colors, paginationText);
		font-family: map-get($fonts, open-semibold);
		font-size: map-get($sizes, small11);
	}
}

.navigation-drawer--temporary:not(.navigation-drawer--close) {
	z-index: 9;
}

.bank-to-bank {
	.input-group--disabled {
		background-color: color(grey) !important;
	}
}

.new-create {
	.input-group__input {
		padding: 0 5px !important;
	}
}

.vue-star-rating-rating-text {
	font-family: font(lato-bold) !important;
	font-size: size(medium);
	margin-top: -2px !important;
}

.configuration-ecommerce {
	.stepper {
		box-shadow: none !important;
	}

	.stepper__header {
		background: map-get($colors, stepper-tabs);
		box-shadow: none !important;
		padding: 0 5%;

		@media (min-width: 768px) {
			padding: 0 7%;
		}
	}

	.stepper__content {
		background: map-get($colors, stepper-content);
		padding: 0 0 0 12px !important;
	}
}

.app-select-full {
	.select-app {
		height: 46px;
	}

	.text-field.input-group--text-field input, .text-field .input-group--text-field textarea {
		color: color(paginationText);
		font-size: size(medium);
	}
}

.reconcilement-checkbox {
	flex: initial;
	min-width: auto;
	width: 138px;

	label {
		min-width: auto;
		width: auto;
	}
}

.border-select {
	.select-app {
		border: 1px solid color(blue-gray);
	}
}

.search-input-container {
	.input-group__input input {
		border-radius: 3px;
		height: 37px !important;
		padding-left: 50px !important;
		padding-right: 14px !important;
	}

	.filter-select.input-group .input-group__icon-clearable {
		color: color(error) !important;
		font-size: size(medium20) !important;
	}
}

.products-search-form {
	.material-icons, label {
		font-size: 15px;
	}

	.input-group.input-group--selection-controls .input-group__input .icon--selection-control {
		top: 8px;
	}
}

.card-btn {
	.btn__content {
		flex-wrap: wrap;
		padding: 0px;
	}
}

.checkbox-text {
	label {
		color: color(paginationText) !important;
		font-family: font(open-regular) !important;
		font-size: size(small11) !important;
		left: 18px !important;
	}

	.icon--selection-control {
		font-size: size(small) !important;
		height: 12px !important;
		top: 9px !important;
	}
}

.select-outline {
	.select-app {
		background: transparent !important;
		padding-left: 5px !important;
	}

	input {
		color: color(blue-card) !important;
	}

	input::-webkit-input-placeholder {
		color: color(blue-card) !important;
	}

	input::-moz-placeholder {
		color: color(blue-card) !important;
	}

	.icon {
		font-size: size(medium18) !important;
	}

	&.border-outline {
		.select-app {
			border-color: color(dashboard-base);
			border-radius: 18.5px;
			font-family: font(open-bold);
			font-size: size(small11) !important;
			padding-left: 16px !important;
		}

		.input-group__selections__comma {
			color: color(dashboard-base) !important;
			font-family: font(open-bold);
			font-size: size(small11) !important;
		}

		.icon {
			color: color(dashboard-base) !important;
		}
	}
}

.card-checkbox {
	.icon {
		font-size: size(medium15) !important;
		height: 15px !important;
		top: 0px !important;
	}
}

.selling-points {
	.wrapper-text-point {
		&.active {
			label, input {
				color: map-get($colors, paginationText) !important;
			}
		}
	}
}

.table-scroll-tooltip.btn-add {
	.btn--flat {
		background-color: color(white) !important;
		border-radius: 2px !important;
	}
}

.slug-input {
	.filter-select {
		.input-group__input {
			padding-right: 0px !important;
		}

		.icon {
			background-color: color(blue-card) !important;
			border-radius: 2px !important;
			color: color(white) !important;
			font-size: size(medium20) !important;
			height: 30px !important;
			line-height: 30px !important;
			text-align: center !important;
			width: 30px !important;
		}
	}
}

.new-sale {
	.totals-section {
		.btn-totals-sale {
			.material-icons {
				font-size: 12px;
			}
		}
	}
}
	
.gmap-container .menu {
	display: none !important;
}

.content-outline {
	border: 1px solid color(dashboard-base);
	border-bottom-left-radius: 18.5px;
	border-bottom-right-radius: 18.5px;
	border-top-left-radius: 18.5px;
	border-top-right-radius: 18.5px;

	.list__tile {
		height: auto;
	}

	.card, .list {
		background-color: color(background-table) !important;
	}

	.list__tile__title {
		color: color(dashboard-base) !important;
		font-family: font(open-bold) !important;
		font-size: size(small11) !important;
		height: auto;
	}
}

.btn.user-config:hover .btn__content {
	&:before,
	&:after {
		background-color: transparent !important;
	}
}

.page-composite-products-new {
	.select-chips_code {
		.icon {
			display: none;
		}
	}
}

.container-view {
	padding-left: 0;
	transition: 0.05s cubic-bezier(0.4, 0, 0.2, 1);
	&.open {
		padding-left: 149px;
	}
}

.scroll-sidebar-bg {
	overflow-y: auto;
}

.menu-content-actions.menu-content-actions {
	border-radius: 0px;
	
	.list {
		border-radius: 0px;
	}

	.list__tile {
		height: 24px !important;
	}
}

.background-table {
	.overflow-auto {
		margin-bottom: 0;
		overflow: hidden;
		padding: 11px 5px !important;
	}
}

.btn-new-section {
	.btn__content {
		font-size: 14px;
	}
}

.graphic-container > div {
	position: relative !important;
}

.cash-box-close {
	.tabs__div {
		margin-left: initial !important;
		max-width: inherit !important;
		background: map-get($colors, blue-grey);
		width: 50% !important;
	}
	.tabs__slider-wrapper {
		display: none;
	}
	.tabs__item {
		border-bottom: solid 1px map-get($colors, primary);
	}
	.tabs__item--active {
		background: map-get($colors, background-table);
		color: map-get($colors, primary);
		border-top: solid 1px map-get($colors, primary);
		border-left: solid 1px map-get($colors, primary);
		border-right: solid 1px map-get($colors, primary);
		border-bottom: solid 1px map-get($colors, background-table);
	}
}

.new-quotation {
	.filter-select {
		&.input-group {
			&.shadow-inset {
				&-chip {
					top: 23.5px;
				}
			}
		}
	}
}



// .btn {
// 	box-shadow: none!important;
// }

.theme--light .list .list__tile--link:hover, .application .theme--light.list .list__tile--link:hover, .theme--light .list .list__tile--highlighted, .application .theme--light.list .list__tile--highlighted, .theme--light .list .list__group__header:hover, .application .theme--light.list .list__group__header:hover, .theme--light .list .list__group--active:before, .application .theme--light.list .list__group--active:before, .theme--light .list .list__group--active:after, .application .theme--light.list .list__group--active:after{
	background: #5765d9!important;
	color: white!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue